"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _queryStringForAll = _interopRequireDefault(require("query-string-for-all"));

var _reactRouterDom = require("react-router-dom");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _blocks = require("@bueno/blocks");

var _App = require("../../../components/AppChrome/App.constants");

const StyledSearch = _styledComponents.default.div`
  display: inline-flex;
  align-items: center;
  position: relative;
  width: 100%;
  padding: 0 ${_blocks.spacing.snug};
  border: 1px solid ${_blocks.palette.neutral5};
  border-radius: ${_blocks.borderRadius.default};
  overflow: hidden;
  background: ${_blocks.color.pureWhite};

  input {
    display: block;
    height: ${_App.CONTROLS.HEIGHTS.BASE};
    width: 100%;
    padding: 0 ${_blocks.spacing.snug} 0 0;
    border: none;
    appearance: default;
    background: transparent;
    ${_blocks.typography.body}
  }

  /* Hide native search clear icon in webkit */
  input[type='search']::-webkit-search-cancel-button,
  input[type='search']::-webkit-search-decoration {
    -webkit-appearance: none;
  }

  input:focus {
    outline: none;
    box-shadow: none;
  }
`; // TODO: This is be unnecessary once search is in Blocks

const Clear = (0, _styledComponents.default)(_blocks.IconButton)`
  svg {
    height: 16px;
    width: 16px;
  }
`;

class Search extends _react.Component {
  constructor(...args) {
    super(...args);
    (0, _defineProperty2.default)(this, "state", {
      // eslint-disable-next-line
      lastQuery: '',
      query: ''
    });
    (0, _defineProperty2.default)(this, "setQuery", (query = '', updateParams = true) => {
      this.setState({
        // eslint-disable-next-line
        lastQuery: query,
        query
      }, () => {
        this.props.onChange({
          target: {
            value: query
          }
        });

        if (this.props.urlSearchKey && updateParams) {
          this.updateQueryString(query);
        }
      });
    });
    (0, _defineProperty2.default)(this, "updateQueryString", query => {
      const {
        history,
        urlSearchKey
      } = this.props;

      const qs = _queryStringForAll.default.parse(history.location.search);

      if (qs[urlSearchKey] !== undefined && qs[urlSearchKey] === this.state.search) return;
      const activeSearch = query.length > 0 ? query : undefined;

      const stringified = _queryStringForAll.default.stringify({ ...qs,
        [urlSearchKey]: activeSearch
      });

      history.replace({
        search: stringified
      });
    });
    (0, _defineProperty2.default)(this, "resetQuery", () => {
      this.setState(state => ({
        query: state.lastQuery
      }), () => {
        this.props.inputRef.current.select();
      });
    });
    (0, _defineProperty2.default)(this, "handleChange", event => {
      this.setState({
        query: event.target.value
      });
    });
    (0, _defineProperty2.default)(this, "handleSearch", event => {
      if (event.key === 'Enter') {
        this.setQuery(event.target.value);
      }

      if (event.key === 'Escape') {
        this.resetQuery();
      }
    });
    (0, _defineProperty2.default)(this, "clearSearch", () => {
      this.setQuery('');
    });
    (0, _defineProperty2.default)(this, "handleUpdate", () => {
      const {
        query
      } = this.state;
      this.setQuery(query);
    });
    (0, _defineProperty2.default)(this, "showUpdate", () => {
      const {
        onEnter
      } = this.props;
      const {
        query,
        lastQuery
      } = this.state;
      return !onEnter ? false : query.trim() !== lastQuery.trim();
    });
  }

  componentDidMount() {
    const {
      urlSearchKey,
      location
    } = this.props; // If a search param key is provided, set initial search of that parameter's value

    if (urlSearchKey) {
      const query = _queryStringForAll.default.parse(location.search)[urlSearchKey];

      this.setQuery(query, false);
    }
  }
  /**
   * @param {string} query Search query to be used
   * @param {bool} updateParams Flag to say whether to also update url search param
   */


  render() {
    const {
      inputRef,
      isEmpty,
      noClear,
      onChange,
      onEnter,
      placeholder,
      className
    } = this.props;
    const {
      query
    } = this.state;
    return /*#__PURE__*/_react.default.createElement(StyledSearch, {
      className: className
    }, onEnter ? /*#__PURE__*/_react.default.createElement("input", {
      type: "input",
      onKeyDown: this.handleSearch,
      value: query,
      onChange: this.handleChange,
      ref: inputRef,
      placeholder: placeholder,
      "data-cy": "Insights-searchInput"
    }) : /*#__PURE__*/_react.default.createElement("input", {
      type: "search",
      onChange: onChange,
      ref: inputRef,
      placeholder: placeholder
    }), onEnter && !noClear && !isEmpty && !this.showUpdate() && /*#__PURE__*/_react.default.createElement(Clear, {
      className: "t-ClearSearch",
      "data-cy": "Insights-clearSearchInput",
      onClick: this.clearSearch,
      small: true,
      icon: /*#__PURE__*/_react.default.createElement(_blocks.Remove, null)
    }), onEnter && (this.showUpdate() || isEmpty) && /*#__PURE__*/_react.default.createElement(_blocks.IconButton, {
      "data-cy": "Insights-confirmSearch",
      onClick: this.handleUpdate,
      disabled: !this.state.query && !this.state.lastQuery,
      small: true,
      icon: /*#__PURE__*/_react.default.createElement(_blocks.Magnifier, null)
    }));
  }

}

Search.propTypes = {
  className: _propTypes.default.string,
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]),
  inputRef: _propTypes.default.shape({
    current: _propTypes.default.instanceOf(Element)
  }),
  noClear: _propTypes.default.bool,
  onChange: _propTypes.default.func,
  onEnter: _propTypes.default.bool,
  placeholder: _propTypes.default.string,
  initialSearch: _propTypes.default.string,
  urlSearchKey: _propTypes.default.string
};
Search.defaultProps = {
  children: null,
  className: '',
  inputRef: null,
  noClear: false,
  onChange: () => {},
  onEnter: false,
  placeholder: '',
  initialSearch: '',
  history: {
    location: {}
  },
  urlSearchKey: undefined
};

var _default = (0, _reactRouterDom.withRouter)(Search);

exports.default = _default;
module.exports = exports.default;